import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';
import handled from '../../assets/svg/check.svg'
import { Tooltip } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";

import moment from 'moment';
import { API_ENDPOINT } from '../../constants';
import HandleTemplateModal from './scheduleEventHelper/handleTemplateModal';
import UpdateFreeEvent from './scheduleEventHelper/updateFreeEvent';
import UpdateEvent from './scheduleEventHelper/updateEvent';
import { getBackgroundColorForEvent, getTextColor } from '../../helpers/colors';
import UpdateAdministrativeBooking from './administrativeBookings/updateAdministrativeBooking';

const PeopleIcon = () => {
    if (typeof window === 'undefined') return null;
    return <svg style={{ display: 'inline-block' }} width={13} height={13} fill='currentColor' enableBackground="new 0 0 24 24" id="Layer_1" version="1.0" viewBox="0 0 24 24" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g><g><path d="M16.5,14c-1.5,0-2.7,0.4-3.6,0.9c1.4,1.2,2,2.6,2.1,2.7l0.1,0.2V20h8v-2C23,18,21.4,14,16.5,14z" /></g><g><circle cx="16.5" cy="8.5" r="3.5" /></g></g><g><path d="M4,8.5C4,6.6,5.6,5,7.5,5S11,6.6,11,8.5c0,1.9-1.6,3.5-3.5,3.5S4,10.4,4,8.5z M7.5,14C2.6,14,1,18,1,18v2h13v-2   C14,18,12.4,14,7.5,14z" /></g></svg>
}

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

const LightTooltipCheckIn = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(58, 63, 85, 0.9)",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14,
        // minWidth: 500
    }
}))(Tooltip);

function hexToRgba(hex, alpha = 1) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const bigint = parseInt(hex, 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
export const generateTitle = (event, lang = 'se') => {
    let _title = event?._title ?? event?.title;
    let title = '';
    if (event?.hidden) {
        title = 'Unavailable'.translate(lang);
    } else if (event?.type === 'referral') {
        title = event?.reserved ? 'Reserved'.translate(lang) : _title;
    } else if (event?.type === 'revisit') {
        title = _title;
    } else if (event?.type === 'free') {
        title = _title?.translate(lang);
    } else if (event?.type === 'event') {
        title = _title;
    } else if (event?.type === 'administrativeBooking') {
        title = _title;
    } else if (event?.type === 'template') {
        title = _title;
    } else if (event?.type === 'another-clinic') {
        title = 'Booked in another clinic/department'.translate(lang);
    } else if (event?.type === 'take-care') {
        title = _title?.translate(lang);
    } else if (event?.type === 'semble') {
        title = _title?.translate(lang);
    }

    return title;
};

export const EVENT_TYPE = (event, props, isTeam, view, groupData) => {
    const clipboardElement = props.clipboardElement ? true : false;
    const isUpdated = props?.isUpdated ?? false;
    const type = event.type;
    const tsNow = Math.floor(new Date().getTime() / 1000);
    let style = {};
    let className = '';
    if (event?.hidden) {
        className = "custom-calendar-event-wrap event-hidden";
    } else if (type === 'referral') {
        style = event.startTime < tsNow ? { cursor: 'default' } : {};
        className = (props.eventInClipboard && !event.eventId) || event.reserved ?
            'custom-calendar-event-wrap another-clinic-event' :
            !event.eventId && event.scheduledBy == 'patient' ?
                "custom-calendar-event-wrap referral-component-web-booking" :
                !event.eventId && !event.onlineVisit ?
                    "custom-calendar-event-wrap referral-component" :
                    event.onlineVisit && !event.eventId ?
                        "custom-calendar-event-wrap referral-component-online" :
                        "custom-calendar-event-wrap additional-doctor-component";


    } else if (type === 'revisit') {
        style = event.startTime < tsNow ? { cursor: 'default' } : {};
        className = props.eventInClipboard && !event.eventId ?
            'custom-calendar-event-wrap another-clinic-event' :
            !event.eventId && !event.onlineVisit ?
                "custom-calendar-event-wrap control-component" :
                event.onlineVisit && !event.eventId ?
                    "custom-calendar-event-wrap control-component-online" :
                    "custom-calendar-event-wrap additional-doctor-component";


    } else if (type === 'free') {
        const isOtherGreen = event && !event.allActiveForms && (!event.eventForms || (event.eventForms && Array.isArray(event.eventForms) && !event.eventForms.length)) ? true : false;
        style = event.startTime < tsNow ? { cursor: 'default' } : {};

        className = props.eventInClipboard ?
            'custom-calendar-event-wrap another-clinic-event' :
            `custom-calendar-event-wrap ${isOtherGreen ? 'free-component-2' : 'free-component'}`;


    } else if (type === 'event') {
        style = event.startTime < tsNow ? { cursor: 'default' } : {};
        className = props.eventInClipboard ?
            'custom-calendar-event-wrap another-clinic-event' :
            event.additionalDoctor ?
                "custom-calendar-event-wrap additional-doctor-component" :
                "custom-calendar-event-wrap event-component";


    } else if (type === 'administrativeBooking') {
        style = event.startTime < tsNow ? { cursor: 'default' } : {};
        className = props.eventInClipboard ?
            'custom-calendar-event-wrap another-clinic-event' :
            event.additionalDoctor ?
                "custom-calendar-event-wrap additional-doctor-component" :
                "custom-calendar-event-wrap event-component";


    } else if (type === 'template') {
        style = {
            backgroundColor: '#E0BEEC',
            border: '2px dotted #fff',
            color: '#fff'
        };
        if (event.startTime < tsNow) {
            style.cursor = 'default';
        }
        if (event?.templateData?.calendarColor) {
            style.backgroundColor = hexToRgba(event.templateData.calendarColor, 0.7);
            style.color = getTextColor(event.templateData.calendarColor);
        }
        className = props.eventInClipboard ?
            'custom-calendar-event-wrap another-clinic-event' :
            "custom-calendar-event-wrap template-component";


    } else if (type === 'another-clinic') {
        className = 'custom-calendar-event-wrap another-clinic-event';

    } else if (type === 'take-care') {
        className = 'custom-calendar-event-wrap take-care-event-bg';
    } else if (type === 'semble') {
        className = 'custom-calendar-event-wrap take-care-event-bg';
    }

    if (isUpdated && !event?.hidden) {
        className += ' custom-calendar-updated-event';
    }


    const title = props.title;
    const start = props.start;
    const end = props.end;
    const time = props.time;

    if (props.hideTitle && style.cursor == 'default') {
        style.cursor = 'pointer';
    }

    let templateColor = null;
    if (event?.type === 'template' && event.templateData?.calendarColor) templateColor = hexToRgba(event.templateData.calendarColor, 0.7);
    const backgroundColor = getBackgroundColorForEvent(event, props?.selectedGroup, props?.selectedClinic, templateColor);
    const color = getTextColor(backgroundColor);

    if (!props.eventInClipboard) {
        style.backgroundColor = backgroundColor;
        style.color = color;
    }

    // event.isMarkedAsDone = event?.type === 'event' ? event?.isMarkedAsDone?.[event?.doctor] : event?.isMarkedAsDone;

    if (event?.isMarkedAsDone) {
        style.textDecorationLine = 'line-through';
        style.textDecorationThickness = '3px';
    }

    let moreIconSvgStyle = {
        width: 3, minWidth: 3
    }
    if (props.hideTitle) {
        moreIconSvgStyle = {
            width: 2, minWidth: 2
        }
    }

    const isContextMenuOpened = props?.contextMenu?._id === event?._id ? true : false;
    const isClipboardButtonDisabled = !event.eventId && !event.eventFromAnotherClinic && !event?.takeCare && !event?.additionalDoctor && !props.eventInClipboard && !event.reserved && event.startTime > Math.floor(new Date().getTime() / 1000) ? false : true

    return (
        <div
            id={event._id}
            style={style}
            className={className}
            onContextMenu={(e) => {
                e.preventDefault();
                if (clipboardElement || props.eventInClipboard) return;

                if (props.updateEventIsDone && ['agenda', 'day', 'week', 'work_week', 'month'].includes(view) && ['temporaryEvent', 'holiday', 'free', 'template'].indexOf(event?.type) === -1) {
                    if (event._id?.indexOf('additional') !== -1)
                        event._id = event._id.split('additional')[0]; // remove additional part if exists

                    props.updateEventIsDone(!event.isMarkedAsDone, event._id, event?.doctor);
                }
            }}
            onClick={() => {
                if (clipboardElement || props.eventInClipboard) return;
                if (props.handleClickEvent) {
                    props.handleClickEvent(event);
                }
            }}
        // onContextMenu={(e) => {
        //     e.preventDefault();
        //     if (props.hideTitle && props.previewEvent) {
        //         if (props.previewEventState) {
        //             props.previewEvent(null);
        //         } else {
        //             props.previewEvent({
        //                 ...event,
        //                 start,
        //                 end,
        //                 title
        //             });
        //         }

        //     }
        // }}
        >
            <div className='calendar-event-item-header-wrap'>
                <div>
                    <p style={{ whiteSpace: 'nowrap' }}>{time}</p>

                    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                        {
                            groupData?.journalCuroflow?.journalCuroflowApiKey && event?.isMarkedForCheckIn ?
                                <div >
                                    <LightTooltipCheckIn title={'Checked in'.translate(props.lang)} placement="top-start" >
                                        <div>
                                            <Isvg src={handled} width={16} height={16} />
                                        </div>
                                    </LightTooltipCheckIn>
                                </div>
                                :
                                null
                        }
                        {
                            !props.hideTitle ?
                                <p style={isTeam ? {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    gap: 5,
                                } : undefined}>{isTeam ? <span
                                    title={'Includes other caregivers'.translate(props.lang)}
                                >
                                    <PeopleIcon />
                                </span> : null} {title}</p>
                                :
                                null
                        }


                    </div>
                </div>
                {
                    !clipboardElement ?
                        !isClipboardButtonDisabled ?
                            <div className="calendar-event-item-header-more-icon-wrap" onClick={(e) => {
                                e.stopPropagation();
                                if (props.setContextMenu) {
                                    props.setContextMenu(event);
                                }
                            }}
                            >
                                <div>
                                    <Isvg src={moreIcon} style={moreIconSvgStyle} />
                                    {
                                        isContextMenuOpened ?
                                            <div
                                                // className='drag-and-drop-context-menu-overlay-context-menu-wrap'
                                                className={`context-menu-wrap ${props?.rightTooltip ? 'context-menu-event-right-tooltip' : ''} ${props?.bottomTooltip ? 'context-menu-event-bottom-tooltip' : ''}`}
                                                ref={node => {
                                                    if (props?.setContextMenuRef) {
                                                        props.setContextMenuRef(node);
                                                    }
                                                }}
                                            >
                                                <div className={!isClipboardButtonDisabled ? "drag-and-drop-context-menu-overlay-context-menu" : "drag-and-drop-context-menu-overlay-context-menu disabled-context-menu"}>
                                                    <ul>
                                                        <li>
                                                            <button
                                                                onClick={(_e) => {
                                                                    _e.stopPropagation()
                                                                    if (!isClipboardButtonDisabled && props.moveToClipboard) {
                                                                        props.moveToClipboard(props.contextMenu, () => {
                                                                            props.setContextMenu(null);
                                                                        })
                                                                    }
                                                                }}
                                                            >
                                                                {'Move to clipboard'.translate(props.lang)}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>
                                            :

                                            null
                                    }
                                </div>
                            </div>
                            :
                            null

                        :
                        <div className="calendar-event-item-header-more-icon-wrap" onClick={(e) => {
                            e.stopPropagation();
                            if (props.removeFromClipboard) {
                                props.removeFromClipboard(event?._id);
                            }
                        }}
                        >
                            <div style={{ fontSize: 15, right: 5 }}>
                                &times;
                            </div>
                        </div>
                }

            </div>


        </div>
    )
}



class CalendarEventComponent extends React.Component {

    constructor(props) {
        super(props);
        this.contextMenuRef = React.createRef();
        this.state = {

        }
    }



    setInitialData = () => {
        this.checkHeightOfElements();
    }
    checkHeightOfElements = () => {
        if (this.checkHeightOfElementsInterval) {
            clearTimeout(this.checkHeightOfElementsInterval);
        }
        this.checkHeightOfElementsInterval = setTimeout(() => {
            if (typeof window !== 'undefined') {
                let element = document.getElementById(this.props?.event?._id);
                if (element) {
                    const mainHeight = element?.offsetHeight;

                    let childrenHeight = 10;
                    const children = element.children;
                    for (let i = 0; i < children.length; i++) {
                        if (children[i]?.offsetHeight)
                            childrenHeight += children[i].offsetHeight;
                    }
                    if (childrenHeight > mainHeight && !this.state.showTooltipAlways && this.props.numberOfColumns > 0) {
                        this.setState({ showTooltipAlways: true })
                    }
                    // else if (this.state.showTooltipAlways && (childrenHeight <= mainHeight || this.props.numberOfColumns <= 1)) {
                    //     this.setState({ showTooltipAlways: false })
                    // }
                }
            }
        }, 300);
    }



    componentDidMount() {
        this.setInitialData();

        document.addEventListener('mousedown', this.handleClickOutsideContextMenu);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.step !== this.props.step || prevProps.view !== this.props.view || prevProps.numberOfColumns !== this.props.numberOfColumns) {
            this.checkHeightOfElements();
        }

    }
    componentWillUnmount() {
        if (this.checkHeightOfElementsInterval) {
            clearTimeout(this.checkHeightOfElementsInterval);
        }
        this.checkHeightOfElementsInterval = null;

        document.removeEventListener('mousedown', this.handleClickOutsideContextMenu);
    }
    handleClickOutsideContextMenu = (event) => {
        if (this.contextMenuRef && this.contextMenuRef.contains && !this.contextMenuRef.contains(event?.target)) {
            this.setState({ contextMenu: null }, () => {
                if (this.props.setContextMenu) {
                    this.props.setContextMenu(this.state.contextMenu);
                }
            })
        }
    }

    generateHoverTitle = (event) => {
        let _title = event?._hoverTitle ?? event?._title ?? event?.title;
        let title = '';

        let note = '';

        if (event?.hidden) {
            title = 'Unavailable'.translate(this.props.lang);
        } else if (event?.type === 'referral') {
            title = event?.reserved ? 'Reserved'.translate(this.props.lang) : _title;
            note = event?.patientNote || event?.patientControlNote;
        } else if (event?.type === 'revisit') {
            title = _title;
            note = event?.patientNote || event?.patientControlNote;
        } else if (event?.type === 'free') {
            title = _title?.translate(this.props.lang);
        } else if (event?.type === 'event') {
            title = _title;
        } else if (event?.type === 'administrativeBooking') {
            title = _title;
        } else if (event?.type === 'template') {
            title = _title;
        } else if (event?.type === 'another-clinic') {
            title = 'Booked in another clinic/department'.translate(this.props.lang);
        } else if (event?.type === 'take-care') {
            title = _title?.translate(this.props?.lang);
        } else if (event?.type === 'semble') {
            title = _title?.translate(this.props?.lang);
            note = event?.patientNote || event?.patientControlNote;
        }

        if (note && typeof title === 'string') title += ` | ${'Note'.translate(this.props.lang)}: ${note}`;

        let isTeam = false;
        if (this.props.selectedClinic === event?.clinic && ['referral', 'revisit'].includes(event?.type) && event?.additionalDoctors && Array.isArray(event.additionalDoctors) && event.additionalDoctors.length > 0) isTeam = true;

        let visitType;
        if (this.props.selectedClinic === event?.clinic && ['referral', 'revisit'].includes(event?.type)) {
            if (event.type === 'revisit') visitType = 'Revisit/New visit';
            else {
                if (event.scheduledBy === 'patient') visitType = 'Web booking';
                else visitType = 'Booking by clinic';
            }
        }

        if (typeof title === 'string') {
            if (isTeam) title = `(${'Team visit'.translate(this.props.lang)}) ${title}`;
            if (visitType) title += ` (${visitType.translate(this.props.lang)})`;
        }
        if (['event', 'template', 'free'].includes(event?.type) && event?.doctorName) {
            title += `, ${event.doctorName}`;
        }
        if (event?.type === 'free') {
            const webBookingFormsDict = this.props?.webBookingFormsDict ?? {};
            let eventForms = event?.eventForms ?? [];
            const allActiveForms = event?.allActiveForms ?? false;
            if (allActiveForms) {
                eventForms = [];
                const doctorProfessions = event?.doctorProfessions ?? [];
                if (doctorProfessions?.length) {
                    for (var key in webBookingFormsDict) {
                        let professionList = webBookingFormsDict[key]?.professionList ?? [];
                        for (let i = 0; i < professionList.length; i++) {
                            if (doctorProfessions.indexOf(professionList[i]) !== -1) {
                                eventForms.push(key);
                                break;
                            }
                        }
                    }
                }
            }
            let eventFormsNames = [];
            if (eventForms.length && webBookingFormsDict && Object.keys(webBookingFormsDict).length) {
                eventForms.forEach(formId => {
                    if (webBookingFormsDict[formId]?.name) {
                        eventFormsNames.push(webBookingFormsDict[formId]?.name);
                    }
                });
            }
            if (eventFormsNames.length) {
                let firstFive = eventFormsNames.slice(0, 5);
                firstFive = firstFive.map(name => `"${name}"`);
                title += ` | ${firstFive.join(', ')}`;
                if (eventFormsNames.length > 5) {
                    title += ` ${'and'.translate(this.props.lang)} ${eventFormsNames.length - 5} ${'more'.translate(this.props.lang)}`;
                }
            }
        }
        return title;
    };

    getBGColor = (event) => {
        const type = event.type;
        let backgroundColor = "#2A2F35";
        if (event?.hidden) {
            backgroundColor = "rgba(204, 204, 204, 1)"; // opacity 0.4;
        } else if (event.inClipboard) {
            backgroundColor = "rgba(86, 138, 200, 1)"; // opacity 0.5
        } else if (type === 'referral') {
            if (event.reserved) {
                backgroundColor = "rgba(86, 138, 200, 1)"; // opacity 0.5
            } else if (!event.eventId && event.scheduledBy == 'patient') {
                backgroundColor = "#b256c8";
            } else if (!event.eventId && !event.onlineVisit) {
                backgroundColor = "rgb(86, 138, 200)";
            } else if (event.onlineVisit && !event.eventId) {
                backgroundColor = "rgb(58, 63, 86)";
            } else if (event.eventId) {
                backgroundColor = "rgba(253, 171, 148, 1)";
            }
        } else if (type === 'revisit') {
            if (!event.eventId && !event.onlineVisit) {
                backgroundColor = "rgb(96, 190, 187)";
            } else if (event.onlineVisit && !event.eventId) {
                backgroundColor = "rgb(58, 63, 86)";
            } else if (event.eventId) {
                backgroundColor = "rgba(253, 171, 148, 1)";
            }
        } else if (type === 'free') {
            const isOtherGreen = event && !event.allActiveForms && (!event.eventForms || (event.eventForms && Array.isArray(event.eventForms) && !event.eventForms.length)) ? true : false;

            if (isOtherGreen) {
                backgroundColor = "rgba(86, 200, 138, 1)"; // opacity 0.5
            } else {
                backgroundColor = "green";
            }
        } else if (type === 'event') {
            if (event.additionalDoctor) {
                backgroundColor = "rgba(253, 171, 148, 1)"; // opacity 0.6
            } else {
                backgroundColor = "rgb(219, 210, 51)";
            }
        } else if (type === 'template') {
            if (event?.templateData?.calendarColor) {
                backgroundColor = hexToRgba(event.templateData.calendarColor, 1); // opacity 0.7
            } else {
                backgroundColor = "#E0BEEC";
            }
        } else if (type === 'another-clinic') {
            backgroundColor = "rgba(86, 138, 200, 1)"; // opacity 0.5

        } else if (type === 'take-care') {
            backgroundColor = "#e30b5c";
        } else if (type === 'semble') {
            backgroundColor = "#e30b5c";
        }

        return backgroundColor;
    }
    fetchEventData = async (eventId) => {
        if (!eventId || eventId?.length !== 24) return null;

        let response = await fetch(API_ENDPOINT + `/data/calendar/event-data/${eventId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON);
        let result = {};
        if (response?.result?.event) {
            result = response?.result.event;
        }
        if (response?.result?.referral) {
            result.referral = response?.result.referral;
        }
        if (response?.result?.patientProfile) {
            result.patientProfile = response?.result.patientProfile;
        }
        if (Object.keys(result).length === 0) {
            result = null;
        }
        return result;
    }

    handleClickEvent = async (event) => {
        if (event?.type === 'administrativeBooking' && event?._id) {
            this.setState({ updateAdministrativeBookingModal: event?._id }, () => {
                if (this.props.handlingEvent) {
                    this.props.handlingEvent(this.state.updateAdministrativeBookingModal);
                }
            })
            return;
        }

        if (event?.hidden || !event?._id || event?.eventFromAnotherClinic || event?.reserved) return;

        let eventId = event._id;
        if (eventId?.indexOf('additional') !== -1) {
            let splitId = eventId.split('additional');
            eventId = splitId[0];
        }

        let eventData = await this.fetchEventData(eventId)

        const type = eventData?.type;

        let eventStart = new Date(this.props.getStringDateTs(eventData.startTime, 'MM/DD/YYYY HH:mm'));
        let eventEnd = new Date(this.props.getStringDateTs(eventData.endTime, 'MM/DD/YYYY HH:mm'));

        let startDate = moment.unix(Math.floor(eventStart.getTime() / 1000)).format('YYYY-MM-DD');
        let start = moment.unix(Math.floor(eventStart.getTime() / 1000)).format('HH:mm')
        let end = moment.unix(Math.floor(eventEnd.getTime() / 1000)).format("HH:mm");
        let obj = {
            title: event?._title ?? eventData.title,
            titleDoctor: eventData.titleDoctor,
            baseTitle: eventData?.title?.translate(this.props.lang),
            visitReasonName: eventData.visitReasonName,
            _id: eventData._id,
            date: startDate,
            startTime: start,
            endTime: end,
            patientNote: eventData.patientNote,
            patientId: eventData.patientId,
            patientControlNote: eventData.patientControlNote,
            type: eventData.type,
            appointmentPaid: eventData.appointmentPaid,
            additionalDoctor: eventData.additionalDoctor,
            patientProfile: eventData.patientProfile,
            onlineVisit: eventData.onlineVisit ? true : false,
            additionalDoctors: eventData.additionalDoctors,
            closeCaseManually: eventData.closeCaseManually,
            hideTimeFromThePatient: eventData.hideTimeFromThePatient,
            hideDurationForPatient: eventData.hideDurationForPatient,
            allActiveForms: eventData.allActiveForms ?? false,
            eventForms: eventData.eventForms ?? [],
            isColleagueEvent: eventData.isColleagueEvent,
            _2fa: eventData?._2fa ? true : false,
            scheduleKey: eventData.scheduleKey,
            recurringKey: eventData.recurringKey,
            noteToPatient: eventData?.noteToPatient,
            doctor: eventData?.doctor,
            colleagues: eventData?.colleagues,
            guests: eventData?.guests,
            meeting: eventData?.meeting,
            visitReasonPrice: eventData?.visitReasonPrice,
            doctorInfo: eventData?.doctorInfo,
            _doctorInfo: eventData?._doctorInfo,
            additionalDoctorsInfo: eventData?.additionalDoctorsInfo,
            isMarkedAsDone: eventData?.type === 'event' ? eventData?.isMarkedAsDone?.[event?.doctor] : eventData?.isMarkedAsDone,
            isMarkedAsDoneDoctor: event?.doctor,
            createOnWebDoc: eventData?.createOnWebDoc,
            isMarkedForCheckIn: eventData?.isMarkedForCheckIn
        }
        if (type === 'free') {
            obj.allActiveForms = eventData.allActiveForms ? eventData.allActiveForms : false;
            obj.eventForms = eventData.eventForms ? eventData.eventForms : []
            obj.id = event._id

            obj.tsCreated = eventData?.tsCreated;
            obj.tsModified = eventData?.tsModified;

            this.setState({
                schedulePatientTime: obj
            }, () => {
                if (this.props.handlingEvent) {
                    this.props.handlingEvent(this.state.schedulePatientTime);
                }
            })
        } else if (type === 'template') {
            obj.selectedAvailabilityTemplate = {
                ...event?.templateData,
                id: event?.templateData?._id,
            }
            obj.id = event._id

            if (event?.recurringObj) {
                obj.recurring = true;
                obj = { ...obj, ...event.recurringObj }
            }
            obj._date = obj.date;
            obj._startTime = obj.startTime;

            for (var key in obj) {
                if (obj[key] === undefined) {
                    delete obj[key];
                }
            }
            obj.tsCreated = eventData?.tsCreated;
            obj.tsModified = eventData?.tsModified;
            this.setState({
                updateEventTemplatePreModal: obj
            }, () => {
                if (this.props.handlingEvent) {
                    this.props.handlingEvent(this.state.updateEventTemplatePreModal);
                }
            })
        } else {
            if (eventData?.referral) {
                obj.referral = eventData?.referral;
            }
            if (type === 'event') {
                obj.recurringObj = eventData?.recurringObj;

            }
            obj.tsCreated = eventData?.tsCreated;
            obj.tsModified = eventData?.tsModified;

            this.setState({ updateEvent: obj }, () => {
                if (this.props.handlingEvent) {
                    this.props.handlingEvent(this.state.updateEvent);
                }
            })
        }
    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }


    render() {
        const event = this.props.event;

        if (!event || !event?._id) return null;

        const eventType = event.type;

        const styleWidth = this.props.style?.width ?? null;

        const columnWidth = styleWidth ?? this.props.columnWidth ?? 100;

        const updatedLayoutElement = this.props.updatedLayoutElement?.eventId === event?._id ? this.props.updatedLayoutElement : null;

        const hideTitle = columnWidth < 100 ? true : false;
        const start = updatedLayoutElement?.start ?? this.props.getStringDateTs(event.startTime, 'HH:mm');
        const end = updatedLayoutElement?.end ?? this.props.getStringDateTs(event.endTime, 'HH:mm');
        const time = columnWidth > 55 ? `${start} - ${end}` : columnWidth > 30 ? `${start}` : '';
        const title = generateTitle(event, this.props.lang);
        const hoverTitle = this.generateHoverTitle(event);
        const isUpdated = this.props.isUpdated;

        const showHoverTitle = ['referral', 'revisit', 'semble', 'free', 'event', 'template'].includes(eventType) ? true : false;

        // const tooltipBgColor = this.getBGColor(event);
        let templateColor = null;
        if (event?.type === 'template' && event.templateData?.calendarColor) templateColor = hexToRgba(event.templateData.calendarColor, 0.7);
        const tooltipBgColor = getBackgroundColorForEvent(event, this.props.selectedGroup, this.props.selectedClinic, templateColor);
        const rightTooltip = this.props.numberOfColumns > 1 && (this.props.numberOfColumns / 2) > event?.column ? true : false;
        const bottomTooltip = this.props.numberOfColumns === 1 ? true : false;

        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }


        let isTeam = false;
        if (event?.clinic === this.props.selectedClinic && ['referral', 'revisit'].includes(eventType) && event?.additionalDoctors && Array.isArray(event.additionalDoctors) && event.additionalDoctors.length > 0) {
            isTeam = true;
        }

        const eventProps = {
            lang: this.props.lang,
            getStringDateTs: this.props.getStringDateTs,
            hideTitle,
            start,
            end,
            time,
            title,
            isUpdated,
            handleClickEvent: (event) => {
                if (!updatedLayoutElement?.eventId) {
                    this.handleClickEvent(event);
                }
            },
            updateEventIsDone: (isDone, eventId, doctor) => {
                if (this.props.updateEventIsDone) {
                    this.props.updateEventIsDone(isDone, eventId, doctor);
                }
            },
            selectedGroup: this.props.selectedGroup,
            selectedClinic: this.props.selectedClinic,
            setContextMenu: (item) => {
                let contextMenu = item?._id !== this.state.contextMenu?._id ? item : null;
                this.setState({ contextMenu }, () => {
                    if (this.props.setContextMenu) {
                        this.props.setContextMenu(this.state.contextMenu);
                    }
                });
            },
            contextMenu: this.state.contextMenu,
            setContextMenuRef: (ref) => {
                this.contextMenuRef = ref;
            },
            contextMenuRef: this.contextMenuRef,
            rightTooltip,
            bottomTooltip,
            moveToClipboard: (event, callback) => {
                if (this.props.moveToClipboard) {
                    this.props.moveToClipboard(event, callback);
                }
            },
            removeFromClipboard: (eventId, callback) => {
                if (this.props.removeFromClipboard) {
                    this.props.removeFromClipboard(eventId, callback);
                }
            },
            eventInClipboard: this.props.clipboard?.find(el => el._id === event?._id) ? true : false,
        }
        const _contextMenu = this.props._contextMenu;

        const isContextMenuOpened = this.state?.contextMenu?._id === event?._id || _contextMenu ? true : false;
        return (
            <>
                <div className='custom-calendar-event-element-wrap'>
                    {EVENT_TYPE?.(event, eventProps, isTeam, this.props.view, this.getGroupData())}
                </div>

                {/* TODO: check z-index overlap */}
                {
                    (this.state.showTooltipAlways || hideTitle || showHoverTitle) && !updatedLayoutElement && !isContextMenuOpened ?
                        <div className={`custom-calendar-event-tooltip-wrap ${rightTooltip ? 'custom-calendar-event-right-tooltip' : ''} ${bottomTooltip ? 'custom-calendar-event-bottom-tooltip' : ''}`} style={tooltipBgColor ? { backgroundColor: tooltipBgColor, '--before-bg': tooltipBgColor, color: getTextColor(tooltipBgColor) } : {}}>
                            <div className='custom-calendar-event-tooltip' >
                                <p className='custom-calendar-event-tooltip-time'>{start} - {end}</p>
                                <p className='custom-calendar-event-tooltip-title'>{hoverTitle}</p>
                            </div>
                        </div>
                        :
                        null
                }

                {
                    this.state.updateEventTemplatePreModal ?
                        <HandleTemplateModal
                            {...this.props}
                            isOpen={this.state.updateEventTemplatePreModal}
                            fetchItems={this.props.fetchItems}
                            toggle={() => this.setState({ updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal }, () => {
                                if (this.props.handlingEvent) {
                                    this.props.handlingEvent(null);
                                }
                            })}
                        />
                        :
                        null
                }
                {
                    this.state.schedulePatientTime ?
                        <UpdateFreeEvent
                            {...this.props}
                            isOpen={this.state.schedulePatientTime}
                            fetchItems={this.props.fetchItems}
                            toggle={(fetchItems = false) => this.setState({ schedulePatientTime: !this.state.schedulePatientTime }, () => {
                                if (this.props.handlingEvent) {
                                    this.props.handlingEvent(null);
                                }
                                if (fetchItems && this.props.fetchItems) {
                                    this.props.fetchItems();
                                }
                            })}

                        />
                        :
                        null
                }
                {
                    this.state.updateEvent ?
                        <UpdateEvent
                            {...this.props}
                            isOpen={this.state.updateEvent}
                            fetchItems={this.props.fetchItems}
                            updateEventIsDone={(isDone, id, doctor) => {
                                if (this.props.updateEventIsDone) {
                                    this.props.updateEventIsDone(isDone, id, doctor);
                                }
                            }}
                            toggle={(fetchItems = false) => this.setState({ updateEvent: !this.state.updateEvent }, () => {
                                if (this.props.handlingEvent) {
                                    this.props.handlingEvent(null);
                                }
                                if (fetchItems && this.props.fetchItems) {
                                    this.props.fetchItems();
                                }
                            })}

                        />
                        :
                        null
                }
                {
                    this.state.updateAdministrativeBookingModal ?
                        <UpdateAdministrativeBooking
                            {...this.props}
                            eventId={this.state.updateAdministrativeBookingModal}
                            toggle={(callback) => {
                                this.setState({ updateAdministrativeBookingModal: false }, () => {
                                    if (callback) callback();
                                    if (this.props.handlingEvent) {
                                        this.props.handlingEvent(null);
                                    }
                                });
                                this.props.fetchItems();
                            }}
                        />
                        :
                        null
                }

            </>


        )
    }
}

export default CalendarEventComponent;